import React from 'react'
import './history.css';
import history_1 from '../../assets/history_1.JPG';
import history_2 from '../../assets/history_2.JPG';


const History = () => {
  return (
    <div>
      <div className="history">
        <h1>History</h1>
        <img className="history-img" src={history_1} alt="history-img" />
        <p style={{ textAlign: "justify", textIndent: 50, fontSize: 20 }}>
          <br /><t />
          Established in the early 2000s, QuizInc, official quiz club of NIT Durgapur, has grown into a dynamic community passionate about quizzing and knowledge-sharing. From its early days, QuizInc has been a hub for inquisitive minds, fostering a culture of curiosity and intellectual engagement. Over the years, it has evolved into one of the most active student organizations on campus, regularly organizing quizzes, themed events, and interactive sessions that challenge participants to think beyond textbooks. The initial leadership team laid the foundation for a vibrant and intellectually stimulating environment, ensuring that QuizInc became a space for learning, discussion, and creative exploration.
          <br /><br />
        </p>
        <img className="history-img" src={history_2} alt="history-img" />
        <p style={{ textAlign: "justify", fontSize: 20 }}>
          <br />

          Being a part of QuizInc has been an enriching experience for its members, offering opportunities to learn, compete, and grow alongside like-minded peers. The club has successfully hosted flagship events like Qriosity, fandom quizzes, and general trivia contests, along with a diverse range of non-quiz activities such as film screenings, treasure hunts, and interactive discussions. Over the years, QuizInc has expanded its reach by collaborating with premier institutes like IITs and NITs across India, as well as esteemed organizations such as SAIL, DSP, and ICAI. With a commitment to intellectual exploration and creative expression, QuizInc continues to be a platform where ideas thrive, discussions flourish, and minds are constantly challenged beyond the conventional.

          <br />
        </p>
      </div>
    </div>
  )
}

export default History